var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Detalle de Serie - " + _vm.patente },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("br"),
      _c(
        "div",
        { staticClass: "orden_compra", attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            { attrs: { md10: "" } },
            [
              _c(
                "h2",
                {
                  staticClass: "h2_title mb-1",
                  staticStyle: {
                    "text-align": "center",
                    "margin-left": "0",
                    "padding-left": "0",
                    "font-weight": "normal",
                    "margin-top": "40px",
                    "font-size": "2rem"
                  }
                },
                [_vm._v("\n        Última Data Enviada\n      ")]
              ),
              _c(
                "v-card",
                { staticClass: "rounded-card" },
                [
                  _c("v-divider"),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "col-md-12",
                      attrs: { "lazy-validation": "" }
                    },
                    [
                      _c(
                        "v-container",
                        { attrs: { "grid-list-md": "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md12: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: { xs12: "" }
                                    },
                                    [
                                      _c("v-textarea", {
                                        ref: "textarea",
                                        staticClass: "auto-resize",
                                        attrs: {
                                          label: "Data",
                                          rows: "4",
                                          "prepend-icon": "description",
                                          readonly: ""
                                        },
                                        model: {
                                          value: _vm.dato,
                                          callback: function($$v) {
                                            _vm.dato = $$v
                                          },
                                          expression: "dato"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }